import { ConditionBase, ConditionBuilder } from '../condition.type';

export interface ConditionMin extends ConditionBase {
  /**
   * The value of the related field must be greater than or equal to
   * this value for the condition to be fulfilled.
   */
  min: number;
  /**
   * If `true` uses 'greater than'
   * otherwise uses 'greater than or equal to'
   *
   * @default false
   */
  exclusive?: boolean;
}

/**
 * Type guard that checks if an object fulfills the `ConditionMin` interface
 *
 * @param c Non nullish object
 * @returns `true` if `c` satisfies `ConditionMin`
 */
export const isConditionMin = (c: Record<string, any>): c is ConditionMin =>
  'min' in c && typeof c['min'] === 'number';

/**
 * @param condition Condition object
 *
 * @returns
 * Condition function that returns `true` if the value is
 * greater or equal the definied minimum value, otherwise `false`.
 */
export const min: ConditionBuilder<ConditionMin, number> = (condition) => {
  const { min: minValue, exclusive = false } = condition;

  return exclusive
    ? // less than
      (value) => value > minValue
    : // less than or equal to
      (value) => value >= minValue;
};
